import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Alert, Row, Col, Table, Button, Input, Label, FormGroup } from "reactstrap";
import { BASE_URL } from "../../../../constants";
import { IoIosDocument } from "react-icons/io";
import { FaImage } from "react-icons/fa6";

function DepositReportTable({
	propertyAreas,
	reportItems,
	setReportItems,
	isEdit,
	selectedInspections,
	basedOnType,
	setViewItemImage,
}) {

	const formatInspectionActivity = (activity) => {
		return activity
			.replace(/_/g, '-')
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	};

	const getStatusColor = (status) => {
		switch (status) {
			case 'NEW':
				return '#34b4eb';
			case 'SATISFACTORY':
				return '#03a631';
			case 'DAMAGE':
				return '#bd060f';
			case 'ATTENTION':
				return '#e6a800';
			case 'NOT_AVAILABLE':
				return '#e68519';
			default:
				return '#000';
		}
	};

	const formatStatus = (status) => {
		switch (status) {
			case 'NEW':
				return ['N', ' ', '-', ' ', '-', ' ', '-', ' ', '-'];
			case 'SATISFACTORY':
				return ['-', ' ', 'S', ' ', '-', ' ', '-', ' ', '-'];
			case 'DAMAGE':
				return ['-', ' ', '-', ' ', 'D', ' ', '-', ' ', '-'];
			case 'ATTENTION':
				return ['-', ' ', '-', ' ', '-', ' ', '!', ' ', '-'];

			case 'NOT_AVAILABLE':
				return ['-', ' ', '-', ' ', '-', ' ', '-', ' ', 'N/A'];
			default:
				return ['-', ' ', '-', ' ', '-', ' ', '-', ' ', '-'];
		}
	};

	const renderFormattedStatus = (status) => {
		const formattedStatus = formatStatus(status);
		return (
			<span>
				{formattedStatus.map((char, index) => (
					<span key={index} style={{ color: getStatusColor(status), }}>
						{char}
					</span>
				))}
			</span>
		);
	};


	return (
		<Table responsive hover={isEdit}>
			<tbody>
				{propertyAreas.map((area, index) => {
					return (
						<>
							<tr key={index}>
								<th style={{ background: '#eee' }} >{area.area_title}</th>
								{selectedInspections.filter(i => i !== null).map((inspection, index) => {
									return (
										<td key={index} style={{ background: '#eee' }} >
											{inspection !== null ? (
												<>
												<div className="text-center">
													<div style={{ fontWeight: 'bold' }}>{formatInspectionActivity(inspection?.activity)}</div>
													{
														inspection?.is_completed ?
															<div style={{ color: 'green' }}>Completed</div>
															:
															<div style={{ color: 'red' }}>In Progress</div>

													}
												</div>
												<div className="text-center">{new Date(inspection.inspection_date).toLocaleDateString('en-US')}</div>
												</>
											) : '-'}
										</td>
									)
								})}
								<th style={{ background: '#eee' }} className="text-center">S</th>
								<th style={{ background: '#eee' }} className="text-center">P</th>
							</tr>
							{area.items.map((item, itemIndex) => {

								let s = '';
								let p = '';

								if (reportItems.length > 0) {
									const existingItem = reportItems.find(i => i.item_id == item.id && i.property_area_id == area.id);
									if (existingItem) {
										s = existingItem.security_deposit;
										p = existingItem.pet_deposit;
									}
								}

								let bgColor = (isEdit && (s != '' || p != '')) ? '#fff4d4' : 'transparent';

								if (!isEdit && s == '' && p == '') {
									return null; // Skip rendering this item if not in edit mode and no deposits are set
								}

								return (
									<tr key={itemIndex}>
										<td style={{ background: bgColor }}>{item.name}</td>
										{selectedInspections.filter(i => i !== null).map((inspection, ispIdx) => {
											const inspArea = inspection?.areas?.find(a => a.area_id == item.area_id);
											if (inspArea) {
												const inspItem = inspArea.items.find(i => i.item_id == item.id);
												if (inspItem) {
													return (
														<td key={`${itemIndex}-${ispIdx}`} className="text-center" style={{ background: bgColor }}>
															<div className="d-flex justify-content-center gap-5">
																{(inspItem.images && inspItem.images.length > 0) ? (
																	<div>
																		<FaImage style={{ fontSize: '20px' }}
																			onClick={() => {
																				setViewItemImage({
																					itemName: item.name,
																					image: inspItem.images[0].image,
																					createdAt: inspItem.images[0].created_at
																				})
																			}}
																		/>
																	</div>
																) : null}
																<div>{renderFormattedStatus(inspItem.status)}</div>
															</div>
														</td>
													)
												}
											}
											return (
												<td className="text-center" style={{ background: bgColor }}>
													-
												</td>
											)
										})}
										<td className="text-center" style={{ width: '180px', background: bgColor }}>
											{isEdit ? (
												<Input
													type="number"
													style={{
														width: '140px',
														margin: '0 auto',
													}}
													size="sm"
													value={s}
													onChange={(e) => {
														const newReportItems = [...reportItems];
														const existingItemIndex = newReportItems.findIndex(i => i.item_id == item.id && i.property_area_id == area.id);
														if (existingItemIndex > -1) {
															newReportItems[existingItemIndex].security_deposit = e.target.value;
														} else {
															newReportItems.push({
																area_id: area.area_id,
																property_area_id: area.id,
																item_id: item.id,
																security_deposit: e.target.value,
																pet_deposit: p
															});
														}
														setReportItems(newReportItems);
													}}
												/>
											) : (
												<span>{s}</span>
											)}
										</td>
										<td className="text-center" style={{ width: '180px', background: bgColor }}>
											{isEdit ? (
												<Input
													type="number"
													style={{
														width: '140px',
														margin: '0 auto',
													}}
													size="sm"
													value={p}
													onChange={(e) => {
														const newReportItems = [...reportItems];
														const existingItemIndex = newReportItems.findIndex(i => i.item_id == item.id && i.property_area_id == area.id);
														if (existingItemIndex > -1) {
															newReportItems[existingItemIndex].pet_deposit = e.target.value;
														} else {
															newReportItems.push({
																area_id: area.area_id,
																property_area_id: area.id,
																item_id: item.id,
																security_deposit: s,
																pet_deposit: e.target.value
															});
														}
														setReportItems(newReportItems);
													}}
												/>
											) : (
												<span>{p}</span>
											)}
										</td>
									</tr>
								)
							})}

							{(!isEdit) ? (
								<>
									{area.items.filter(item => {
										const existingItem = reportItems.find(i => i.item_id == item.id && i.property_area_id == area.id);
										if (existingItem) {
											return true;
										}

										return false;
									}).length === 0 ? (
										<tr>
											<td colSpan={3 + selectedInspections.filter(i => i !== null).length} className="text-center text-muted">No items available</td>
										</tr>
									) : null}
								</>
							) : null}
						</>
					)
				})}
			</tbody>
		</Table>
	)
}

export default DepositReportTable